import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)



export default new Router({
  routes: [{
    path: '/',
    redirect: '/dashboard'
  }, {
    path: '/',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    meta: { title: '公共页面' },
    children: [
      {
        path: '/dashboard',
        component: resolve => require(['../components/pages/Dashboard.vue'], resolve),
        meta: { title: '系统首页' }
      }, {
        path: '/newBuilt',
        component: resolve => require(['../components/pages/newBuilt.vue'], resolve),
        meta: { title: '诊断信息' }
      }, {
        path: '/newBuilt1',
        component: resolve => require(['../components/pages/newBuilt1.vue'], resolve),
        meta: { title: '诊断详情' }
      }, {
        path: '/patientTable',
        component: resolve => require(['../components/pages/patientTable.vue'], resolve),
        meta: { title: '患者管理' }
      }, {
        path: '/rollIn',
        component: resolve => require(['../components/pages/rollIn.vue'], resolve),
        meta: { title: '转入' }
      }, {
        path: '/rollOut',
        component: resolve => require(['../components/pages/rollOut.vue'], resolve),
        meta: { title: '转出' }
      }, {
        path: '/newRollout',
        component: resolve => require(['../components/pages/newRollout.vue'], resolve),
        meta: { title: '添加转诊' }
      }, {
        path: '/showRollout',
        component: resolve => require(['../components/pages/showRollout.vue'], resolve),
        meta: { title: '转诊信息' }
      }, {
        path: '/lookInfo',
        component: resolve => require(['../components/pages/lookInfo.vue'], resolve),
        meta: { title: '患者详情' }
      }, {
        path: '/searchUser',
        component: resolve => require(['../components/pages/searchUser.vue'], resolve),
        meta: { title: '患者查询' }
      }, {
        path: '/userReport',
        component: resolve => require(['../components/pages/userReport.vue'], resolve),
        meta: { title: '患者报告' }
      }, {
        path: '/quality',
        component: resolve => require(['../components/pages/quality.vue'], resolve),
        meta: { title: '质控管理' }
      }, {
        path: '/qualityUser',
        component: resolve => require(['../components/pages/qualityUser.vue'], resolve),
        meta: { title: '患者列表' }
      }, {
        path: '/drug',
        component: resolve => require(['../components/pages/drug.vue'], resolve),
        meta: { title: '药库信息' }
      }, {
        path: '/test',
        component: resolve => require(['../components/pages/test.vue'], resolve),
        meta: { title: '诊断信息' }
      },]
  }, {
    path: '/login',
    component: resolve => require(['../components/login/Login.vue'], resolve)
  },
  {
    path: '*',
    redirect: '/404'
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js